import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hmsFromSeconds',
})
export class HmsFromSecondsPipe implements PipeTransform {
    transform(value: number): string {
        const h: number = Math.floor(value / 3600);
        const m: number = Math.floor((value % 3600) / 60);
        const s: number = value % 60;
        return `${this.pad(h)}:${this.pad(m)}:${this.pad(s)}`;
    }

    private pad(n: number): string {
        return n < 10 ? `0${n}` : `${n}`;
    }
}
